export const GET_CUSTOMER = 'GET_CUSTOMER';
export const GET_CUSTOMER_ORDERS = 'GET_CUSTOMER_ORDERS';
export const DEACTIVATE_CUSTOMER = 'DEACTIVATE_CUSTOMER';
export const ACTIVATE_CUSTOMER = 'ACTIVATE_CUSTOMER';